import { render } from "./EventsCardVES.vue?vue&type=template&id=56093b01&scoped=true&ts=true"
import script from "./EventsCardVES.vue?vue&type=script&lang=ts"
export * from "./EventsCardVES.vue?vue&type=script&lang=ts"

import "./EventsCardVES.vue?vue&type=style&index=0&id=56093b01&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56093b01"]])

export default __exports__